"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteObjectById = void 0;
const deleteObjectById = (_id, data) => {
    const deleteObject = (obj) => {
        if (Array.isArray(obj)) {
            return obj.filter((item) => item._id !== _id).map(deleteObject);
        }
        else if (typeof obj === 'object' && obj !== null) {
            if (obj._id === _id) {
                return undefined;
            }
            return Object.fromEntries(Object.entries(obj)
                .filter(([key, value]) => !(key === '_id' && value === _id))
                .map(([key, value]) => [key, deleteObject(value)]));
        }
        return obj;
    };
    return deleteObject(data);
};
exports.deleteObjectById = deleteObjectById;
